export const zeroBasedIncrementingArray = (size) => {
  const result = new Uint8Array(size)
  result.forEach((_, index, array) => {
    array[index] = index
  })
  return result
}

export const incrementingArray = (size) => {
  return zeroBasedIncrementingArray(size).map((elem) => {
    return elem + 1
  })
}

export const shuffleArray = (incoming) => {
  const result = [...incoming]

  // Perform the Fisher‑Yates algorithm
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]]
  }

  return result
}
